module.exports = __webpack_public_path__ + "img/coin.e573a05a.png";